module.exports = __webpack_public_path__ + "7c52846dc16f8c219da1d8d628c297b5.svg";